import { logger } from '~/utils/sentry/client-only-logger'
import { analytics } from './segment-analytics'

/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const useLoadSegment = (writeKey: string) =>
  clientOnly(() => {
    try {
      analytics.load({ writeKey })
    } catch (error) {
      const formatError = (e: unknown) =>
        new Error('Failed to load Segment analytics', { cause: e })

      logger.error(error, { formatError })
    }
  })
